const CONTRIBUTION_MULTIPLIER = {
  weekly: 52,
  monthly: 12,
  yearly: 1
};

export const formatCurrency = (amount) => (
  Number(amount).toLocaleString("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
);

export const calculateCompoundGrowth = (initialInvestment, contributionAmount, contributionFrequency, returnRate, years) => {
  const annualReturn = returnRate / 100;
  const contributionsPerYear = CONTRIBUTION_MULTIPLIER[contributionFrequency] || CONTRIBUTION_MULTIPLIER.monthly;
  const yearlyContribution = contributionAmount * contributionsPerYear;

  let totalValue = initialInvestment;
  let totalContributions = initialInvestment;
  const yearlyData = [];

  if (initialInvestment > 0) {
    yearlyData.push({ year: 0, totalValue, totalContributions, totalInterest: 0 });
  }

  for (let year = 1; year <= years; year += 1) {
    totalValue += yearlyContribution;
    totalContributions += yearlyContribution;
    totalValue *= (1 + annualReturn);

    yearlyData.push({
      year,
      totalValue,
      totalContributions,
      totalInterest: totalValue - totalContributions
    });
  }

  return yearlyData;
};

export const initInvestmentCalculatorPage = () => {
  const form = document.getElementById("investment-form");
  if (!form) return;

  const resultsContainer = document.getElementById("results");
  const totalAmountEl = document.getElementById("totalAmount");
  const totalContributionsEl = document.getElementById("totalContributions");
  const totalInterestEl = document.getElementById("totalInterest");
  const growthTableBody = document.getElementById("growthTableBody");

  document.querySelectorAll(".scenario-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.getElementById("initialInvestment").value = btn.getAttribute("data-initial");
      document.getElementById("contributionAmount").value = btn.getAttribute("data-amount");
      document.getElementById("contributionFrequency").value = btn.getAttribute("data-frequency");
      document.getElementById("interestRate").value = btn.getAttribute("data-rate");
      document.getElementById("years").value = btn.getAttribute("data-years");
      form.dispatchEvent(new Event("submit"));
    });
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    const formData = new FormData(form);
    const initialInvestment = Number(formData.get("initialInvestment")) || 0;
    const contributionAmount = Number(formData.get("contributionAmount"));
    const contributionFrequency = formData.get("contributionFrequency");
    const years = Number(formData.get("years"));
    const returnRate = Number(formData.get("interestRate"));

    if (contributionAmount <= 0 && initialInvestment <= 0) {
      alert("Please enter either a contribution amount or initial investment.");
      return;
    }

    if (years < 1 || years > 50) {
      alert("Please enter a timeline between 1 and 50 years.");
      return;
    }

    const yearlyData = calculateCompoundGrowth(initialInvestment, contributionAmount, contributionFrequency, returnRate, years);
    const finalYear = yearlyData[yearlyData.length - 1];

    totalAmountEl.textContent = formatCurrency(finalYear.totalValue);
    totalContributionsEl.textContent = formatCurrency(finalYear.totalContributions);
    totalInterestEl.textContent = formatCurrency(finalYear.totalInterest);

    growthTableBody.innerHTML = "";
    const showInterval = years <= 10 ? 1 : 5;

    yearlyData.forEach((data) => {
      if (data.year === 0 || data.year % showInterval === 0 || data.year === years) {
        const row = document.createElement("tr");
        row.innerHTML = `
          <td class="year-col">Year ${data.year}</td>
          <td class="amount-col">${formatCurrency(data.totalValue)}</td>
          <td class="contributions-col">${formatCurrency(data.totalContributions)}</td>
          <td class="interest-col">${formatCurrency(data.totalInterest)}</td>
        `;
        growthTableBody.appendChild(row);
      }
    });

    resultsContainer.classList.add("visible");
    resultsContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
  });
};
